import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Field, reduxForm } from 'redux-form'
import { withRouter } from 'react-router'

import * as ROUTES from 'config/routes'
import * as validate from './validate'
import {Alert, Button, Col, Icon, PreLoader, Row, SubmitRow, Select, TextInput, TextInput as Input} from 'elements'
import { AvatarField, SwitchField, TextField, SelectStatusField } from 'components'
import './index.scss'
import { detectablesListSelector, holderSchedulesSelector, schedulesSelector, verticalConfigSelector } from 'redux/selectors'
import { listDetectables } from 'redux/modules/model/detectable'
import { listHolderSchedules, listSchedules } from 'redux/modules/model/attendance'
import { withClientId } from 'hocs'
import { base64EncodeArrayBuffer, getImageData, formatImageDataBase64Uri, arrayBufferDecodeBase64 } from 'utils/helpers'
import ContactScheduleAssignments from '../../pages/directory/contact-details/components/attendance/contact-schedule-assignments'

const { TextArea } = Input;

const COMPONENT_CSS_CLASSNAME = 'holder-form'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`
const detectableKeyFormat = (detectableType, detectableId) => `${detectableType}:${detectableId}`
class HolderForm extends Component {
  constructor (props) {
    super(props)
    const { initialValues } = props
    this.state = {
      holderBuffer: {
        clientReference: initialValues ? initialValues.clientReference : '',
        name: initialValues ? initialValues.name : '',
        holderType: 'contact',
        active: initialValues ? initialValues.active : true,
        image: initialValues
          ? initialValues.image
            ? {data: getImageData(initialValues.image.data), mimeType: initialValues.image.mimeType}
            : null
          : null,
        email: initialValues ? initialValues.metadata ? initialValues.metadata['e-mail'] : '': '',
        company: initialValues ? initialValues.metadata ? initialValues.metadata.Company : '': '',
        memberType: initialValues ? initialValues.metadata ? initialValues.metadata['Membership type'] : '': '',
        topSpender: initialValues && initialValues.metadata ? initialValues.metadata['Top Spender'] : true,
      },
      detectablesAddQueue: [],
      detectablesRemoveQueue: [],
      schedulesAddQueue: [],
      schedulesRemoveQueue: []
    }
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    error: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func
  }

  handleCancel = () => {
    const { history, initialValues } = this.props
    const clientReference = get(initialValues, 'clientReference')
    history.goBack()
  }

  componentDidMount() {
    const { clientId, listDetectables, listHolderSchedules, listSchedules, match } = this.props
    const { clientReference } = match.params
    listDetectables({ clientId, assignment: clientReference })
    listSchedules({clientId})
    listHolderSchedules({clientId, clientReference})
  }

  editDetectablesAddQueue = (index, key, value) => {
    this.setState((state) => ({
      detectablesAddQueue: state.detectablesAddQueue.map((detectable, i) => (
        index === i
          ? { ...detectable,
              [key]: value }
          : detectable )) }))
  }

  editSchedulesAddQueue = (index, key, value) => {
    this.setState((state) => ({
      schedulesAddQueue: state.schedulesAddQueue.map((schedule, i) => (
        index === i
          ? {
            ...schedule,
            [key]: value
          }
          : schedule
      ))
    }))
  }

  editHolderBuffer = (key, value) => {
    this.setState((state) => ({
      holderBuffer: {
        ...state.holderBuffer,
        [key]: value } }))
  }

  pushDetectablesAddQueue = () => {
    this.setState((state) => ({
      detectablesAddQueue: [
        ...state.detectablesAddQueue,
        { detectableType: 'uhf-epc',
          detectableId: '',
          description: '' } ] }))
  }

  pushDetectablesRemoveQueue = (detectableType, detectableId) => {
    this.setState({detectablesRemoveQueue: [
      ...this.state.detectablesRemoveQueue,
      {detectableType, detectableId}]})
  }

  pushSchedulesAddQueue = () => {
    this.setState((state) => ({
      schedulesAddQueue: [
        ...state.schedulesAddQueue,
        { scheduleId: '' }
      ]
    }))
  }

  pushSchedulesRemoveQueue = (scheduleId) => {
    this.setState((state) => (
      ! state.schedulesRemoveQueue.includes(scheduleId) && {
        schedulesRemoveQueue: [
          ...state.schedulesRemoveQueue,
          scheduleId
        ]
      }
    ))
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { clientId, initialValues, onSubmit } = this.props
    const { detectablesAddQueue, detectablesRemoveQueue, holderBuffer, schedulesAddQueue, schedulesRemoveQueue } = this.state
    const { clientReference, holderType } = holderBuffer
    const editMode = Boolean(get(initialValues, 'clientReference'))
    onSubmit({
      addDetectables: detectablesAddQueue.map((detectable) => ({
        clientId,
        ...detectable,
        active: true,
        assignment: clientReference })),
      addHolder: ! editMode && {
        clientId,
        clientReference,
        holderType,
        name: holderBuffer.name,
        note: holderBuffer.note,
        active: holderBuffer.active,
        image: holderBuffer.image && holderBuffer.image.data,
        metadata: {
          ['e-mail']: holderBuffer.email,
          ['Company']: holderBuffer.company,
          ['Membership type']: holderBuffer.memberType,
          ['Top Spender']: holderBuffer.topSpender
        } },
      editDetectables: detectablesRemoveQueue.map((detectable) => ({
        clientId,
        ...detectable,
        changes: {
          assignment: null } })),
      editHolder: editMode && {
        clientId,
        clientReference,
        holderType,
        changes: {
          name: holderBuffer.name,
          note: holderBuffer.note,
          active: holderBuffer.active,
          image: holderBuffer.image && holderBuffer.image.data,
          metadata: {
            ['e-mail']: holderBuffer.email,
            ['Company']: holderBuffer.company,
            ['Membership type']: holderBuffer.memberType,
            ['Top Spender']: holderBuffer.topSpender
          } } },
      addAssignments: schedulesAddQueue.map((schedule) => ({
        clientId,
        clientReference,
        ...schedule })),
      removeAssignments: schedulesRemoveQueue.map((scheduleId) => ({
        clientId,
        clientReference,
        scheduleId }))
    })
  }

  render() {
    const { error, initialValues, detectablesList, holderSchedules, schedules, match, verticalConfig } = this.props
    const { clientReference } = match.params
    const editMode = Boolean(get(initialValues, 'clientReference'))
    const existingDetectables = detectablesList.filter((detectable) => (detectable.assignment === clientReference))
      .map((item) => {
        const queuedForDeletion = Boolean(this.state.detectablesRemoveQueue.find(
            (e) => (e.detectableType === item.detectableType && e.detectableId === item.detectableId)))
        return (
          <div
              className={bemE('detectable')}
              key={detectableKeyFormat(item.detectableType, item.detectableId)}
              style={queuedForDeletion ? {opacity: 0.35} : null} >
            <div className={bemE('detectable-name')}>
              <span className={bemE('detectable-type')}>{item.detectableType}</span>
              {' '}
              <span className={bemE('detectable-id')}>{item.detectableId}</span>
              {(editMode && ! queuedForDeletion) && (
                <button type="button"
                    className={bemE('action')}
                    onClick={() => {this.pushDetectablesRemoveQueue(item.detectableType, item.detectableId)}} >
                  <Icon type="minus-circle-o"/> Remove
                </button> )}
            </div>
            <div className={bemE('detectable-description')}>{item.description}</div>
          </div>)})
    const newDetectables = this.state.detectablesAddQueue.map((detectable, index) => (
      <div key={index} className={bemE('new-detectable-item')}>
        <Select
            className={bemE('new-detectable-type')}
            defaultValue='uhf-epc'
            onChange={(value) => {this.editDetectablesAddQueue(index, 'detectableType', value)}}
        >
          <Option value="uhf-epc">UHF-EPC</Option>
          <Option value="mifare-csn">MIFARE-CSN</Option>
        </Select>
        <TextInput
            className={bemE('new-detectable-id')}
            onChange={(event) => {this.editDetectablesAddQueue(index, 'detectableId', event.target.value)}}
            placeholder="ID"
            value={detectable.detectableId}
        />
      </div>
    ))
    const newSchedules = this.state.schedulesAddQueue.map((schedule, index) => (
      <div key={index} className={bemE('new-schedule-item')}>
        <Select
            className={bemE('new-schedule-id')}
            filterOption={(inputValue, option) => (
              !! `${option.props.value}\n${option.props.children}`.toLowerCase().includes(inputValue.toLowerCase())
            )}
            onChange={(value) => {this.editSchedulesAddQueue(index, 'scheduleId', value)}}
            placeholder='Schedule ID'
            showSearch
        >
          {schedules && schedules.map((schedule) => (
            (
              ! this.state.schedulesAddQueue.find((addSchedule) => (addSchedule.scheduleId === schedule.scheduleId)) &&
              ! holderSchedules.find((scheduleId) => (scheduleId === schedule.scheduleId))
            ) &&
              <Select.Option key={schedule.scheduleId} value={schedule.scheduleId}>{`${schedule.scheduleId}: ${schedule.name}`}</Select.Option>
          ))}
        </Select>
      </div>
    ))

    return (
      <form onSubmit={this.handleSubmit} className={COMPONENT_CSS_CLASSNAME}>
        {error && <Alert message={error} type="error" className={bemE('error')} />}
        <Field
          name="name"
          label="Name"
          htmlType="text"
          validate={[validate.nameIsRequired]}
          component={TextField}
          onChange={(event) => {this.editHolderBuffer('name', event.target.value)}}
        />
        {this.props.clientId !== 'gleneagles' && (
          <div>
            <Field
              name="note"
              label="Note"
              component={TextField}
              onChange={(event) => {this.editHolderBuffer('note', event.target.value)}}
            />
            <Field
              name="metadata.e-mail"
              label="e-mail"
              component={TextField}
              onChange={(event) => {this.editHolderBuffer('email', event.target.value)}}
            />
            <Field
              name="metadata.Company"
              label={'Company'}
              component={TextField}
              onChange={(event) => {this.editHolderBuffer('company', event.target.value)}}
            />
            <Field
              name="metadata.Membership type"
              label={'Membership type'}
              component={TextField}
              onChange={(event) => {this.editHolderBuffer('memberType', event.target.value)}}
            />
          </div>
        )}
        {this.props.clientId === 'gleneagles' && (
          <div>
            <Field
              name="topSpender"
              label="Top Spender"
              options={[{label:"True",value:"active"}, {label:"False",value:"deactivated"}]}
              component={SelectStatusField}
              onChange={(event) => {
                if(event === 'active'){
                  this.editHolderBuffer('topSpender', true)
                } else{
                  this.editHolderBuffer('topSpender', false)
                }
              }}
            />
          </div>
        )}
        {!editMode && (
          <Field
            name="clientReference"
            label="ID number"
            htmlType="text"
            validate={[validate.clientReferenceIsRequired]}
            component={TextField}
            onChange={(event) => {this.editHolderBuffer('clientReference', event.target.value)}}
          />
        )}
        {editMode && (
          <Field
          name="inactive"
          label="Status"
          options={[{label:"Active",value:"active"}, {label:"Deactivated",value:"deactivated"}]}
          component={SelectStatusField}
          onChange={(event) => {
            if(event === 'active'){
              this.editHolderBuffer('active', true)
            } else{
              this.editHolderBuffer('active', false)
            }
          }}
        />
        )}
        <Row>
          <Col xs={12}>
            <Field
              name="image"
              label="Photo (optional)"
              component={AvatarField}
              onChange={(event) => {
                this.editHolderBuffer('image', (event.data && event.mimeType)
                  ? {data: getImageData(event.data), mimeType: event.mimeType}
                  : null )}}
            />
          </Col>
        </Row>
        {(editMode || existingDetectables.length > 0) && (
          <h3 className={bemE('section-title')}>
            Detectables
            {editMode && (
              <button type="button"
                  className={bemE('action')}
                  onClick={() => {this.pushDetectablesAddQueue()}} >
                <Icon type="plus-circle-o"/> Add
              </button> )}
          </h3> )}
        {existingDetectables}
        {editMode && newDetectables}
        {editMode && verticalConfig.attendance &&
          <React.Fragment>
            <h3 className={bemE('section-title')}>
              Schedules
              <button type="button"
                  className={bemE('action')}
                  onClick={() => {this.pushSchedulesAddQueue()}} >
                <Icon type="plus-circle-o"/> Add
              </button>
            </h3>
            <ContactScheduleAssignments clientReference={clientReference} edit removeCallback={this.pushSchedulesRemoveQueue} removeQueue={this.state.schedulesRemoveQueue} />
            {editMode && newSchedules}
          </React.Fragment>
        }
        {!this.props.loading ? (
            <SubmitRow>
              <Row type="flex" gutter={20}>
                <Col>
                  <Button htmlType="submit" type="primary" wide>
                    Save
                  </Button>
                </Col>
                <Col>
                  <Button wide onClick={this.handleCancel}>Cancel</Button>
                </Col>
              </Row>
            </SubmitRow>
        ) : (<PreLoader />)}
      </form>
    )
  }
}

export const selector = createStructuredSelector({
  detectablesList: detectablesListSelector,
  holderSchedules: holderSchedulesSelector,
  schedules: schedulesSelector,
  verticalConfig: verticalConfigSelector
})

export const actions = {
  listDetectables,
  listHolderSchedules,
  listSchedules
}

export default compose(
  withClientId,
  withRouter,
  connect(selector, actions),
  reduxForm({
    form: 'holderForm',
    enableReinitialize: true
  })
)(HolderForm)



// WEBPACK FOOTER //
// ./src/smart-components/holder-form/index.js